import context from "./context.js";
import axios from "axios";
import moment from "moment-timezone";

const APRequestRoleHeader = "AP-Request-Role"
const APClientOlsonTimezone = "AP-Client-Olson-Timezone"

class Ajax {

    constructor() {

        let commonHeader = {
            [APClientOlsonTimezone]: moment.tz.guess(), // 12/18/17 bring back Client's timezone feature
            [APRequestRoleHeader]: window.__ap_request_role || "",
            // [APClientOlsonTimezone]: "America/Los_Angeles", // hardcoded due to discussuion on 6/5/17, keep CA time, UPDATE : 12/18/17 bring back Client's timezone feature
        };

        this.apiConfig = {
            baseURL: context.apiRoot() + "/",
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.legacyConfig = {
            baseURL: context.legacyRoot() + "/",
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.vmConfig = {
            baseURL: context.url("app/api/view-model/"),
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.publicApiConfig = {
            baseURL: context.url("app/public-api"),
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.securityConfig = {
            baseURL: context.url("app/security/"),
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.popupConfig = {
            baseURL: context.url("app/popup/"),
            timeout: 120000,
            headers: Object.assign({
            }, commonHeader)
        };

        this.api = this.api.bind(this);
        this.legacy = this.legacy.bind(this);
        this.vm = this.vm.bind(this);
        this.popup = this.popup.bind(this);
        this.responseInterceptor = this.responseInterceptor.bind(this);
        this.errorInterceptor = this.errorInterceptor.bind(this);
        this.createInstance = this.createInstance.bind(this);
        this.setAjaxRequestRole = this.setAjaxRequestRole.bind(this);
    }

    /**
     * 
     * @param {string} role 
     */
    setAjaxRequestRole(role) {
        window.__ap_request_role = role;

        this.apiConfig.headers = Object.assign(this.apiConfig.headers,
            {
                [APRequestRoleHeader]: window.__ap_request_role
            });

        this.legacyConfig.headers = Object.assign(this.legacyConfig.headers,
            {
                [APRequestRoleHeader]: window.__ap_request_role
            });

        this.vmConfig.headers = Object.assign(this.vmConfig.headers,
            {
                [APRequestRoleHeader]: window.__ap_request_role
            });

        this.publicApiConfig.headers = Object.assign(this.publicApiConfig.headers,
            {
                [APRequestRoleHeader]: window.__ap_request_role
            });
    }

    popup() {
        this.popupConfig.headers = Object.assign(this.popupConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.popupConfig);
    }

    security() {
        this.securityConfig.headers = Object.assign(this.securityConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.securityConfig);
    }

    api() {
        this.apiConfig.headers = Object.assign(this.apiConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.apiConfig);
    }

    legacy() {
        this.legacyConfig.headers = Object.assign(this.legacyConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.legacyConfig);
    }

    vm() {
        this.vmConfig.headers = Object.assign(this.vmConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.vmConfig);
    }

    public() {
        this.publicApiConfig.headers = Object.assign(this.publicApiConfig.headers,
            {
                [APClientOlsonTimezone]: moment.tz.guess()
            });
        return this.createInstance(this.publicApiConfig);
    }

    /**
     * 
     * @param {*} config 
     * @returns {import("axios").AxiosInstance}
     */
    createInstance(config) {
        const instance = axios.create(config);
        instance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
        return instance;
    }

    errorInterceptor(err) {
        if (err.response.data.code == 0x10000004) {
            window.location = context.routeUrl("home?msg=You%20are%20not%20allowed%20to%20enter%20current%20week%20timecard%20from%20outside%20Company%E2%80%99s%20domain");
        } else if (err.response.status == 401) {
            window.location = context.routeUrl("login?msgcode=1");
            // context.message({
            //     show: true,
            //     type: "error",
            //     buttons: "close",
            //     message: "Access Denied! You are not authorized to access the requested resource."                
            // }, function (button, state) {                

            // });        
        } else if (err.response.status == 403) {
            const data = err.response.data;
            const message = data.exceptionMessage || data.message;

            if (message.toLowerCase().indexOf("no current user") > -1)
                window.location = context.routeUrl("login?msgcode=1");
            else
                window.location = context.routeUrl(`home?msg=${encodeURI("Access denied")}`);
        }
        return Promise.reject(err);
    }

    responseInterceptor(response) {
        return response;
    }
}

var ajax = new Ajax();

export default ajax;
